import { render, staticRenderFns } from "./CommLogItem.vue?vue&type=template&id=ace97aae&scoped=true&"
import script from "./CommLogItem.vue?vue&type=script&lang=js&"
export * from "./CommLogItem.vue?vue&type=script&lang=js&"
import style0 from "./CommLogItem.vue?vue&type=style&index=0&id=ace97aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace97aae",
  null
  
)

export default component.exports